import React from 'react';
import { SurveyImportElementsAndUnitsNotFoundError } from '../../../../common/src/imports/surveyImport';
import { SurveyImportElementsNotFoundErrorRow } from './SurveyImportElementsNotFoundErrorRow';

export function SurveyImportErrorRow(props: {
    message: string;
    error?: SurveyImportElementsAndUnitsNotFoundError | undefined;
    clientCompanyId: string | undefined;
    ownerCompanyId: string | undefined;
}) {
    if (!props.error) {
        return <>{props.message}</>;
    }
    if (props.error instanceof SurveyImportElementsAndUnitsNotFoundError) {
        return (
            <SurveyImportElementsNotFoundErrorRow error={props.error} clientCompanyId={props.clientCompanyId} ownerCompanyId={props.ownerCompanyId} />
        );
    }
    return <>{props.message}</>;
}
